import makeStyles from '@mui/styles/makeStyles';

import { borderColor, darkGray, surfaceElevated, surfaceSecondary, teal900 } from '@/theme/colors';

export const useStyles = makeStyles({
  formContent: {
    padding: '16px 24px',
    backgroundColor: surfaceElevated,
  },
  instructions: {
    fontSize: 14,
    color: darkGray,
    textAlign: 'center',
    margin: '0 0 20px 0',
  },
  phoneSection: {
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 350,
    margin: '0 auto 16px',
  },
  phoneInputWrapper: {
    width: '100%',
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      backgroundColor: surfaceElevated,
      fontSize: 14,
      '& fieldset': {
        borderColor: borderColor,
      },
      '&:hover fieldset': {
        borderColor: '#9CA3AF',
      },
      '&.Mui-focused fieldset': {
        borderColor: teal900,
        borderWidth: 1,
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: 14,
      color: darkGray,
      '&.Mui-focused': {
        color: 'var(--brandPrimary)',
      },
    },
    '& .MuiInputAdornment-root': {
      marginRight: 0,
    },
    '& .MuiFormHelperText-root': {
      fontSize: 12,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  emailInput: {
    width: 350,
    padding: '10px 12px',
    border: `1px solid ${borderColor}`,
    borderRadius: 4,
    fontSize: 14,
    '&:focus': {
      outline: 'none',
      borderColor: teal900,
      boxShadow: `0 0 0 1px ${teal900}`,
    },
    '&::placeholder': {
      color: '#9CA3AF',
    },
  },
  consentSection: {
    marginTop: 20,
    maxWidth: 350,
    margin: '20px auto 0',
  },
  consentLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    cursor: 'pointer',
  },
  consentCheckbox: {
    marginTop: 2,
    width: 16,
    height: 16,
    accentColor: teal900,
  },
  consentText: {
    fontSize: 13,
    color: darkGray,
    lineHeight: 1.4,
  },
  loginLinkContainer: {
    textAlign: 'center',
    marginTop: 20,
  },
  loginLink: {
    fontSize: 14,
    color: 'var(--brandPrimary)',
    textDecoration: 'none',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  errorMessage: {
    backgroundColor: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: 4,
    padding: 12,
    marginBottom: 16,
    textAlign: 'center',
  },
  errorText: {
    fontSize: 14,
    color: '#DC2626',
    margin: 0,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    borderTop: `1px solid ${borderColor}`,
    backgroundColor: surfaceSecondary,
  },
  backButton: {
    color: 'var(--brandPrimary)',
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 8,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  sendButton: {
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '10px 24px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#004544',
    },
    '&:disabled': {
      backgroundColor: '#D1D5DB',
      color: '#9CA3AF',
      cursor: 'not-allowed',
    },
  },
});
